import { Fragment, useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  DvrOutlined,
  Diversity2Outlined,
  Healing,
  HomeOutlined,
  LocalPharmacyOutlined,
  DriveFileRenameOutline,
  MedicationOutlined,
  ImageOutlined,
  TaskOutlined,
  SentimentSatisfiedOutlined,
  RestaurantMenu,
  VerifiedUserOutlined,
  ExpandMore,
  MonitorHeartOutlined,
  MasksOutlined,
  SickOutlined,
  PsychologyOutlined,
  ErrorOutlineOutlined,
  AutorenewOutlined,
} from '@mui/icons-material';

import Survey from '../Survey';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRef: any;
}

const MenuRecords = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth, coachRef } = props;

  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const menus = [
    {
      icon: <DvrOutlined />,
      label: 'e-CARDEX',
    },
    {
      disabled: true,
      icon: <AutorenewOutlined />,
      label: 'SBAR',
      id: 'sbar',
    },
    {
      label: 'SBAR 1',
      toggle: toggle.sbar,
    },
    {
      icon: <Diversity2Outlined />,
      label: 'Y tá phụ trách',
    },
    {
      icon: <Healing />,
      label: 'Hồ sơ bệnh án nội trú',
    },
    {
      icon: <HomeOutlined />,
      label: 'Hồ sơ xuất viện',
    },
    {
      icon: <LocalPharmacyOutlined />,
      label: 'Lịch sử kê đơn',
    },
    {
      icon: <DriveFileRenameOutline />,
      label: 'Hồ sơ điều dưỡng',
    },
    {
      icon: <MedicationOutlined />,
      label: 'Hồ sơ sử dụng thuốc',
    },
    {
      icon: <ImageOutlined />,
      label: 'Hồ sơ chẩn đoán hình ảnh',
    },
    {
      icon: <TaskOutlined />,
      label: 'Bệnh lý lâm sàng',
    },
    {
      disabled: true,
      icon: <MonitorHeartOutlined />,
      label: 'Hồ sơ theo\ndõi lâm sàng',
      id: 'clinical_obv',
    },
    {
      label: 'Chỉ số sinh\ntồn VS',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'I/O',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'Đường\nhuyết',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'Theo dõi lâm sàng (ICU)',
      toggle: toggle.clinical_obv,
    },
    {
      disabled: true,
      icon: <SentimentSatisfiedOutlined />,
      label: 'Đánh giá\nbệnh nhân',
      id: 'patient_evaluation',
    },
    {
      label: 'Thang điểm đo nguy cơ\nté ngã Mouse',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Thang điểm nguy cơ té\nngã Humpty Dumpty',

      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Thang đo Braden',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Đánh giá\nnhu cầu',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Thang điểm\nGCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Thang điểm GCS trẻ em',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Thang điểm FOUR',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Báo cáo an toàn người bệnh',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Hệ thống học tập và báo\ncáo về an toàn người bệnh',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Hệ thống báo cáo tác dụng phụ của thuốc',
      toggle: toggle.patient_evaluation,
    },

    {
      icon: <SickOutlined />,
      disabled: true,
      label: 'Đánh giá\nđiểm đau',
      id: 'pain',
    },
    {
      label: 'Thang đo\nNRS',
      toggle: toggle.pain,
    },
    {
      label: 'Thang đo\nFLACC',
      toggle: toggle.pain,
    },
    // {
    //   label: 'CNPS',
    //   toggle: toggle.pain,
    // },
    {
      label: 'FFI',
      toggle: toggle.pain,
    },
    {
      label: 'KOOS',
      toggle: toggle.pain,
    },
    {
      label: 'LEFS',
      toggle: toggle.pain,
    },
    {
      label: 'NDI',
      toggle: toggle.pain,
    },
    {
      label: 'Sàng lọc\nSTaT-Back',
      toggle: toggle.pain,
    },
    {
      icon: <PsychologyOutlined />,
      disabled: true,
      label: 'Tâm thần\nhọc',
      id: 'mental_health',
    },
    {
      label: 'Hồ sơ sức khỏe tâm\nthần',
      toggle: toggle.mental_health,
    },
    {
      label: 'BDI',
      toggle: toggle.mental_health,
    },
    {
      label: 'BAI',
      toggle: toggle.mental_health,
    },
    {
      label: 'MMSE',
      toggle: toggle.mental_health,
    },

    {
      disabled: true,
      icon: <MasksOutlined />,
      label: 'Hồ sơ đặc\nbiệt',
      id: 'special',
    },
    {
      label: 'Phẫu thuật',
      toggle: toggle.special,
    },
    {
      label: 'Gây mê',
      toggle: toggle.special,
    },
    {
      label: 'Truyền máu',
      toggle: toggle.special,
    },
    {
      label: 'Đặt nội\nkhí quản',
      toggle: toggle.special,
    },
    {
      label: 'CPR',
      toggle: toggle.special,
    },
    {
      label: 'Lọc máu',
      toggle: toggle.special,
    },
    {
      label: 'Cấp cứu',
      toggle: toggle.special,
    },
    {
      label: 'Sinh sản',
      toggle: toggle.special,
    },
    {
      label: 'Chăm sóc\ntại nhà',
      toggle: toggle.special,
    },
    {
      icon: <RestaurantMenu />,
      label: 'Dinh dưỡng\nvà chế độ ăn',
    },
    {
      disabled: true,
      icon: <VerifiedUserOutlined />,
      label: 'Điều khoản và thoả thuận',
      id: 'agreement',
    },
    {
      label: 'Hướng dẫn\nbệnh nhân',
      toggle: toggle.agreement,
    },
    {
      label: 'Biểu mẫu chấp\nthuận của\nbệnh nhân',
      toggle: toggle.agreement,
    },
    {
      label: 'Truyền máu ',
      toggle: toggle.agreement,
    },
    {
      label: 'An thần\ncó ý thức',
      toggle: toggle.agreement,
    },
    {
      label: 'DNR',
      toggle: toggle.agreement,
    },
    {
      label: 'Thoả thuận đồng ý nhập viện',
      toggle: toggle.agreement,
    },
    {
      label: 'Hướng dẫn nhập viện',
      toggle: toggle.agreement,
    },
    {
      label: 'Danh sách kiểm tra\nnhập viện',
      toggle: toggle.agreement,
    },
    {
      label: 'Phòng ngừa\nté ngã',
      toggle: toggle.agreement,
    },
    {
      label: 'CRRT',
      toggle: toggle.agreement,
    },
    {
      label: 'Đặt CVC',
      toggle: toggle.agreement,
    },
    {
      label: 'ETI',
      toggle: toggle.agreement,
    },
    {
      label: 'Sự kiềm chế bằng phương pháp vật lý',
      toggle: toggle.agreement,
    },
    // {
    //   icon: <BabyChangingStation />,
    //   label: 'Children Examination',
    // },
    {
      disabled: true,
      icon: <ErrorOutlineOutlined />,
      label: 'Informatics\nand Nursing',
      id: 'information',
    },
    {
      label: 'Hồ sơ điều dưỡng AI tạo sinh',
      toggle: toggle.information,
    },
    {
      label: 'Chat\nGPT',
      toggle: toggle.information,
    },
    {
      label: 'Google\nGemini',
      toggle: toggle.information,
    },
  ];

  const onClickListItem = (label: string) => {
    if (!student_uuid) return onRequired('REQUIRED.STUDENT');

    if (label === 'Hệ thống học tập và báo\ncáo về an toàn người bệnh') {
      window.open('https://psnet.ahrq.gov/');
      return;
    } else if (label === 'Hệ thống báo cáo tác dụng phụ của thuốc') {
      window.open('https://who-umc.org/');
      return;
    } else if (label === 'Hồ sơ điều dưỡng AI tạo sinh') {
      window.open('https://chatbot2-enr-vn.streamlit.app/');
      return;
    } else if (label === 'Chat\nGPT') {
      window.open('https://chat.openai.com/chat');
      return;
    } else if (label === 'Google\nGemini') {
      window.open('https://bard.google.com/');
      return;
    }

    if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    // if (menuDrawerWidth !== 300) {
    //   if (sublabel) newToggle[sublabel] = true;
    //   setToggle(newToggle);
    //   setMenuDrawerWidth(300);
    //   return;
    // }

    if (sublabel === 'sbar') {
      newToggle['sbar'] = !newToggle['sbar'];
      newToggle['clinical_obv'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'clinical_obv') {
      newToggle['clinical_obv'] = !newToggle['clinical_obv'];
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'patient_evaluation') {
      newToggle['patient_evaluation'] = !newToggle['patient_evaluation'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'pain') {
      newToggle['pain'] = !newToggle['pain'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'mental_health') {
      newToggle['mental_health'] = !newToggle['mental_health'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'special') {
      newToggle['special'] = !newToggle['special'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'agreement') {
      newToggle['agreement'] = !newToggle['agreement'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'information') {
      newToggle['information'] = !newToggle['information'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
    }

    setToggle(newToggle);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, disabled, toggle, id }) => {
        const onClick = () => {
          if (disabled) onClickDisabledItem(id);
          else onClickListItem(label);
        };

        const MoreIcon = () => {
          if (!disabled) return null;
          return <ExpandMore fontSize="small" sx={{ color: '#fff' }} />;
        };

        if (disabled) {
          return (
            <>
              {icon ? (
                <ListItem
                  key={label}
                  disablePadding
                  ref={label === 'Special part Record' ? coachRef : null}
                  sx={{ whiteSpace: 'pre-wrap' }}
                >
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        margin: '6.5px 0 6px 0',
                        justifyContent: 'center',
                        width: '80px',
                      }}
                    >
                      {icon}
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                    />
                  </ListItemButton>
                </ListItem>
              ) : toggle ? (
                <ListItem key={label} disablePadding>
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                      sx={{ whiteSpace: 'pre-wrap' }}
                    />
                  </ListItemButton>
                </ListItem>
              ) : (
                <></>
              )}
            </>
          );
        }

        return (
          <>
            {icon ? (
              <ListItem
                key={label}
                disablePadding
                ref={label === 'Special part Record' ? coachRef : null}
                sx={{ whiteSpace: 'pre-wrap' }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width: '80px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      margin: '6.5px 0 6px 0',
                      justifyContent: 'center',
                      width: '80px',
                      '&:hover': {
                        color: 'red',
                      },
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{
                      fontSize: '12px',
                      textAlign: 'center',
                      marginTop:
                        label === 'Hồ sơ chẩn đoán hình ảnh' ? '-12px' : '',
                    }}
                    primary={label}
                  />
                </ListItemButton>
              </ListItem>
            ) : toggle ? (
              <ListItem
                key={label}
                disablePadding
                sx={{
                  width:
                    label ===
                    'Hệ thống học tập và báo\ncáo về an toàn người bệnh'
                      ? '120px'
                      : label === 'Hệ thống báo cáo tác dụng phụ của thuốc'
                      ? '150px'
                      : '100px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width:
                      label ===
                      'Hệ thống học tập và báo\ncáo về an toàn người bệnh'
                        ? '120px'
                        : label === 'Hệ thống báo cáo tác dụng phụ của thuốc'
                        ? '150px'
                        : '100px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                    backgroundColor: 'white',
                    ':hover': {
                      boxShadow: '1px 0px 3px 0px #E2E2E2',
                      borderRadius: '8px',
                    },
                  }}
                >
                  <div
                    style={{
                      height: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'white',
                      marginTop: '-0.5px',
                      borderRadius: '8px',
                    }}
                  >
                    <ListItemText
                      className="DropMenu"
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                        fontWeight: 500,
                      }}
                      primary={label}
                    />
                  </div>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}
          </>
        );
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuRecords;
